import {decodeResolver} from "./dataTypeResolver";

// Knowledge Catalog items (t5/v1/catalog_items -> v1.CatalogItem-001).
export const V1CatalogTermIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["PlatformMessage"] && input["PlatformMessage"]["ListOfCatalogTerm"] !== undefined) {
        output["Count"] = input["PlatformMessage"]["ListOfCatalogTerm"].Count === undefined ? 0 : input["PlatformMessage"]["ListOfCatalogTerm"].Count;

        let results: any[] = [];

        if ("CatalogTerm" in input["PlatformMessage"]["ListOfCatalogTerm"]) {
            let node = input["PlatformMessage"]["ListOfCatalogTerm"]["CatalogTerm"];
            let rows = Array.isArray(node) ? node : [node];

            for (let i = 0; i < rows.length; i++) {
                let link = rows[i];
                let row: any = {};

                row.RowNum = i;
                row.RowSelected = false;

                row.USID = link.USID;
                row.SourceUSID = link.SourceUSID;
                row.SourceType = link.SourceType;
                row.EnterpriseTermUSID = link.EnterpriseTermUSID;
                // Resolved server-side through the term's current released revision, so a renamed
                // term shows its new name without the link being touched.
                row.TermName = link.TermName;
                row.TermDescription = link.TermDescription;
                row.CreatedDatetime = link.CreatedDatetime;
                row.LastModifiedDatetime = link.LastModifiedDatetime;
                row.Action = null;

                row["__operation"] = "query results";

                results.push(row);
            }
        }

        output["Results"] = results;
    }

    return output;
};

export const V1CatalogAttributeIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["PlatformMessage"] && input["PlatformMessage"]["ListOfCatalogAttribute"] !== undefined) {
        output["Count"] = input["PlatformMessage"]["ListOfCatalogAttribute"].Count === undefined ? 0 : input["PlatformMessage"]["ListOfCatalogAttribute"].Count;

        let results: any[] = [];

        if ("CatalogAttribute" in input["PlatformMessage"]["ListOfCatalogAttribute"]) {
            let node = input["PlatformMessage"]["ListOfCatalogAttribute"]["CatalogAttribute"];
            let rows = Array.isArray(node) ? node : [node];

            for (let i = 0; i < rows.length; i++) {
                let attribute = rows[i];
                let row: any = {};

                row.RowNum = i;
                row.RowSelected = false;

                row.USID = attribute.USID;
                row.CatalogItemRevisionUSID = attribute.CatalogItemRevisionUSID;
                row.Name = attribute.Name;
                row.Description = attribute.Description;
                row.DataType = attribute.DataType;
                row.OriginalType = attribute.OriginalType;
                row.AttributeOrder = attribute.AttributeOrder;
                row.IsNullable = attribute.IsNullable;
                row.Constraints = attribute.Constraints;
                row.CreatedDatetime = attribute.CreatedDatetime;
                row.LastModifiedDatetime = attribute.LastModifiedDatetime;
                row.Action = null;

                row["__operation"] = "query results";

                results.push(row);
            }
        }

        output["Results"] = results;
    }

    return output;
};

export const V1SourceIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["PlatformMessage"] && input["PlatformMessage"]["ListOfSource"] !== undefined) {
        output["Count"] = input["PlatformMessage"]["ListOfSource"].Count === undefined ? 0 : input["PlatformMessage"]["ListOfSource"].Count;

        let results: any[] = [];

        if ("Source" in input["PlatformMessage"]["ListOfSource"]) {
            let node = input["PlatformMessage"]["ListOfSource"]["Source"];
            let rows = Array.isArray(node) ? node : [node];

            for (let i = 0; i < rows.length; i++) {
                let source = rows[i];
                let row: any = {};

                row.RowNum = i;
                row.RowSelected = false;

                row.USID = source.USID;
                row.Name = source.Name;
                row.Description = source.Description;
                // The three stewardship owners. The API has always returned them and the EC has
                // always declared them; this converter simply never copied them across, so every
                // read of a source came back with the owners blank -- the Visibility pane reported
                // "Primary Position: Not set" for sources that have had one since they were created,
                // and the detail form showed three empty pickers.
                row.PrimaryPositionUSID = source.PrimaryPositionUSID;
                row.PrimaryUserGroupUSID = source.PrimaryUserGroupUSID;
                row.PrimaryWorkGroupUSID = source.PrimaryWorkGroupUSID;
                // Lifecycle status, and the primary position's NAME joined server-side. Both feed
                // columns in the sources list, and both are read-only here -- the record stores a
                // position USID, so a rename is picked up on the next read with no backfill.
                // Named "PrimaryPositionName" to match Enterprise Terms and Data Quality Rules, which show
                // the same value in the same column.
                row.Status = source.Status;
                row.PrimaryPositionName = source.PrimaryPositionName;
                // Whether we may make this source's database do the counting when rules run. A
                // field nobody copies here is silently absent everywhere, which is how the three
                // stewardship owners above went missing.
                row.AllowPushdown = source.AllowPushdown;
                row.CreatedDatetime = source.CreatedDatetime;
                row.LastModifiedDatetime = source.LastModifiedDatetime;
                row.Action = null;

                row["__operation"] = "query results";

                results.push(row);
            }
        }

        output["Results"] = results;
    }

    return output;
};

export const V1LocationIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["PlatformMessage"] && input["PlatformMessage"]["ListOfLocation"] !== undefined) {
        output["Count"] = input["PlatformMessage"]["ListOfLocation"].Count === undefined ? 0 : input["PlatformMessage"]["ListOfLocation"].Count;

        let results: any[] = [];

        if ("Location" in input["PlatformMessage"]["ListOfLocation"]) {
            let node = input["PlatformMessage"]["ListOfLocation"]["Location"];
            let rows = Array.isArray(node) ? node : [node];

            for (let i = 0; i < rows.length; i++) {
                let location = rows[i];
                let row: any = {};

                row.RowNum = i;
                row.RowSelected = false;

                row.USID = location.USID;
                row.SourceUSID = location.SourceUSID;
                // The picker reads this to nest each option under its parent.
                row.ParentUSID = location.ParentUSID;
                row.LocationType = location.LocationType;
                row.Name = location.Name;
                row.OriginPath = location.OriginPath;
                row.Description = location.Description;
                row.CreatedDatetime = location.CreatedDatetime;
                row.LastModifiedDatetime = location.LastModifiedDatetime;
                row.Action = null;

                row["__operation"] = "query results";

                results.push(row);
            }
        }

        output["Results"] = results;
    }

    return output;
};

export const V1RelationshipTypeIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["PlatformMessage"] && input["PlatformMessage"]["ListOfRelationshipType"] !== undefined) {
        output["Count"] = input["PlatformMessage"]["ListOfRelationshipType"].Count === undefined ? 0 : input["PlatformMessage"]["ListOfRelationshipType"].Count;

        let results: any[] = [];

        if ("RelationshipType" in input["PlatformMessage"]["ListOfRelationshipType"]) {
            let node = input["PlatformMessage"]["ListOfRelationshipType"]["RelationshipType"];
            let rows = Array.isArray(node) ? node : [node];

            for (let i = 0; i < rows.length; i++) {
                let rt = rows[i];
                let row: any = {};

                row.RowNum = i;
                row.RowSelected = false;

                row.USID = rt.USID;
                row.Name = rt.Name;
                row.TargetRelationshipName = rt.TargetRelationshipName;
                row.SourceRelationshipName = rt.SourceRelationshipName;
                // Which kind of record the type is for. Copied like any other field -- a converter
                // that omits it leaves the scoped pickers filtering on a value the buffer never got.
                row.ObjectType = rt.ObjectType;
                row.CreatedDatetime = rt.CreatedDatetime;
                row.LastModifiedDatetime = rt.LastModifiedDatetime;
                row.Realm = rt.Realm;
                row.Action = null;

                row["__operation"] = "query results";

                results.push(row);
            }
        }

        output["Results"] = results;
    }

    return output;
};

export const V1CatalogItemIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["PlatformMessage"] && input["PlatformMessage"]["ListOfCatalogItem"] !== undefined) {
        output["Count"] = input["PlatformMessage"]["ListOfCatalogItem"].Count === undefined ? 0 : input["PlatformMessage"]["ListOfCatalogItem"].Count;

        let results: any[] = [];

        if ("CatalogItem" in input["PlatformMessage"]["ListOfCatalogItem"]) {
            let node = input["PlatformMessage"]["ListOfCatalogItem"]["CatalogItem"];
            let rows = Array.isArray(node) ? node : [node];

            for (let i = 0; i < rows.length; i++) {
                let ci = rows[i];
                let row: any = {};

                row.RowNum = i;
                row.RowSelected = false;

                row.USID = ci.USID;
                row.Name = ci.Name;
                row.Description = ci.Description;
                row.OverallQuality = ci.OverallQuality;
                row.NumberOfAttributes = ci.NumberOfAttributes;
                row.NumberOfRecords = ci.NumberOfRecords;
                row.Origin = ci.Origin;
                row.ItemType = ci.ItemType;
                row.SourceUSID = ci.SourceUSID;
                row.LocationUSID = ci.LocationUSID;
                row.ConnectionUSID = ci.ConnectionUSID;
                row.CatalogItemUSID = ci.CatalogItemUSID;
                row.Revision = ci.Revision;
                row.Status = ci.Status;
                row.ApprovalStatus = ci.ApprovalStatus;
                // The document sends a real boolean; a string "false" would be truthy here.
                row.IsCurrent = ci.IsCurrent;
                row.CreatedByUSID = ci.CreatedByUSID;
                row.PrimaryPositionUSID = ci.PrimaryPositionUSID;
                // As on rules and sources: the position's name, joined server-side.
                row.PrimaryPositionName = ci.PrimaryPositionName;
                row.PrimaryUserGroupUSID = ci.PrimaryUserGroupUSID;
                row.PrimaryWorkGroupUSID = ci.PrimaryWorkGroupUSID;
                row.CreatedDatetime = ci.CreatedDatetime;
                row.LastModifiedDatetime = ci.LastModifiedDatetime;
                row.Realm = ci.Realm;
                row.Action = null;

                row["__operation"] = "query results";

                results.push(row);
            }
        }

        output["Results"] = results;
    }

    return output;
};

// Enterprise Glossary terms (t5/v1/enterprise_term_revisions -> v1.EnterpriseTermRevision-001).
export const V1EnterpriseTermRevisionIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["PlatformMessage"] && input["PlatformMessage"]["ListOfEnterpriseTermRevision"] !== undefined) {
        output["Count"] = input["PlatformMessage"]["ListOfEnterpriseTermRevision"].Count === undefined ? 0 : input["PlatformMessage"]["ListOfEnterpriseTermRevision"].Count;

        let results: any[] = [];

        if ("EnterpriseTermRevision" in input["PlatformMessage"]["ListOfEnterpriseTermRevision"]) {
            let node = input["PlatformMessage"]["ListOfEnterpriseTermRevision"]["EnterpriseTermRevision"];
            let rows = Array.isArray(node) ? node : [node];

            for (let i = 0; i < rows.length; i++) {
                let et = rows[i];
                let row: any = {};

                row.RowNum = i;
                row.RowSelected = false;

                row.USID = et.USID;
                row.EnterpriseTermUSID = et.EnterpriseTermUSID;
                // WHO CREATED THE REVISION. Carried by the idoc all along and dropped here, which is
                // why the detail page could not tell whether the caller was the record's creator --
                // and so could not decide whether to offer the lifecycle buttons. The server lets a
                // creator make those moves without <type>:edit (creator_authorizes_transition).
                row.CreatedByUSID = et.CreatedByUSID;
                row.Revision = et.Revision;
                row.Status = et.Status;
                row.ApprovalStatus = et.ApprovalStatus;
                // True on the one revision the term currently resolves to (latest PUBLISHED, else
                // DRAFT) — what the relationship term pickers filter on to list one row per term.
                row.IsCurrent = et.IsCurrent;
                row.Name = et.Name;
                row.Type = et.Type;
                row.Abbreviation = et.Abbreviation;
                row.Description = et.Description;
                row.OverallQuality = et.OverallQuality;
                row.PrimaryPositionName = et.PrimaryPositionName;
                row.PrimaryUserGroupPrimaryAccountUserName = et.PrimaryUserGroupPrimaryAccountUserName;
                row.PrimaryWorkGroupPrimaryAccountUserName = et.PrimaryWorkGroupPrimaryAccountUserName;
                row.Source = et.Source;
                row.PrimaryPositionUSID = et.PrimaryPositionUSID;
                row.PrimaryUserGroupUSID = et.PrimaryUserGroupUSID;
                row.PrimaryWorkGroupUSID = et.PrimaryWorkGroupUSID;
                row.CreatedDatetime = et.CreatedDatetime;
                row.LastModifiedDatetime = et.LastModifiedDatetime;
                row.EffectiveDatetime = et.EffectiveDatetime;
                row.ApprovedDatetime = et.ApprovedDatetime;
                row.Realm = et.Realm;
                row.Action = null;

                row["__operation"] = "query results";

                results.push(row);
            }
        }

        output["Results"] = results;
    }

    return output;
};

// Enterprise Term relationships (t5/v1/enterprise_term_relationships -> v1.EnterpriseTermRelationship-001).
export const V1EnterpriseTermRelationshipIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["PlatformMessage"] && input["PlatformMessage"]["ListOfEnterpriseTermRelationship"] !== undefined) {
        output["Count"] = input["PlatformMessage"]["ListOfEnterpriseTermRelationship"].Count === undefined ? 0 : input["PlatformMessage"]["ListOfEnterpriseTermRelationship"].Count;

        let results: any[] = [];

        if ("EnterpriseTermRelationship" in input["PlatformMessage"]["ListOfEnterpriseTermRelationship"]) {
            let node = input["PlatformMessage"]["ListOfEnterpriseTermRelationship"]["EnterpriseTermRelationship"];
            let rows = Array.isArray(node) ? node : [node];

            for (let i = 0; i < rows.length; i++) {
                let r = rows[i];
                let row: any = {};

                row.RowNum = i;
                row.RowSelected = false;

                row.USID = r.USID;
                row.ParentUSID = r.ParentUSID;
                row.ChildUSID = r.ChildUSID;
                row.RelationshipTypeUSID = r.RelationshipTypeUSID;
                row.ParentName = r.ParentName;
                row.ChildName = r.ChildName;
                // ParentUSID/ChildUSID are LOGICAL term USIDs; these resolve each end to the term's
                // current revision. The revision USIDs are what the Term Detail route is keyed on.
                row.ParentStatus = r.ParentStatus;
                row.ChildStatus = r.ChildStatus;
                row.ParentRevisionUSID = r.ParentRevisionUSID;
                row.ChildRevisionUSID = r.ChildRevisionUSID;
                row.RelationshipTypeName = r.RelationshipTypeName;
                // The type's two directional readings: Source = the parent's role, Target = the child's.
                row.SourceRelationshipName = r.SourceRelationshipName;
                row.TargetRelationshipName = r.TargetRelationshipName;
                row.CreatedDatetime = r.CreatedDatetime;
                row.LastModifiedDatetime = r.LastModifiedDatetime;
                row.Realm = r.Realm;
                row.Action = null;

                row["__operation"] = "query results";

                results.push(row);
            }
        }

        output["Results"] = results;
    }

    return output;
};

// Normalize the audit CHANGE payload to an array of {Field Path, Previous Value, Next Value, ...}.
// StorageTypeJSON may surface it as a base64 string, a JSON string, or an already-parsed object.
const decodeAuditChange = (value: any): any[] => {
    if (value === null || value === undefined || value === "") return [];
    if (Array.isArray(value)) return value;
    if (typeof value === "object") return Object.values(value);
    if (typeof value === "string") {
        for (const candidate of [() => JSON.parse(atob(value)), () => JSON.parse(value)]) {
            try {
                const parsed = candidate();
                if (Array.isArray(parsed)) return parsed;
                if (parsed && typeof parsed === "object") return Object.values(parsed);
            } catch (e) { /* try next */ }
        }
    }
    return [];
};

// Term audit trail (t5/v1/enterprise_term_audit_histories). Flat list under
// ListOfEnterpriseTermAuditHistory; Change is normalized to an array of per-field diffs.
export const V1EnterpriseTermAuditHistoryIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["PlatformMessage"] && input["PlatformMessage"]["ListOfEnterpriseTermAuditHistory"] !== undefined) {
        output["Count"] = input["PlatformMessage"]["ListOfEnterpriseTermAuditHistory"].Count === undefined ? 0 : input["PlatformMessage"]["ListOfEnterpriseTermAuditHistory"].Count;

        let results: any[] = [];

        if ("EnterpriseTermAuditHistory" in input["PlatformMessage"]["ListOfEnterpriseTermAuditHistory"]) {
            let node = input["PlatformMessage"]["ListOfEnterpriseTermAuditHistory"]["EnterpriseTermAuditHistory"];
            let rows = Array.isArray(node) ? node : [node];

            for (let i = 0; i < rows.length; i++) {
                let r = rows[i];
                let row: any = {};

                row.RowNum = i;
                row.RowSelected = false;

                row.USID = r.USID;
                row.ModificationType = r.ModificationType;
                row.SessionIdentifier = r.SessionIdentifier;
                row.EnterpriseTermUSID = r.EnterpriseTermUSID;
                row.EnterpriseTermRevisionUSID = r.EnterpriseTermRevisionUSID;
                row.RevisionName = r.RevisionName;
                row.EnterpriseTermRelationshipUSID = r.EnterpriseTermRelationshipUSID;
                row.TermSynonymUSID = r.TermSynonymUSID;
                row.TermClassificationUSID = r.TermClassificationUSID;
                row.CreatedByUSID = r.CreatedByUSID;
                row.CreatedByName = r.CreatedByName;
                row.CreatedByEmail = r.CreatedByEmail;
                row.Change = decodeAuditChange(r.Change);
                row.CreatedDatetime = r.CreatedDatetime;
                row.LastModifiedDatetime = r.LastModifiedDatetime;
                row.Realm = r.Realm;
                row.Action = null;

                row["__operation"] = "query results";

                results.push(row);
            }
        }

        output["Results"] = results;
    }

    return output;
};

// Synonyms nested under the first matched EnterpriseTermRevision (mirror of
// V1OrganizationDataDomainIDOCToArray): drills ListOfEnterpriseTermRevision.EnterpriseTermRevision[0]
// .ListOfTermSynonym.TermSynonym.
export const V1TermSynonymIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["PlatformMessage"] && input["PlatformMessage"]["ListOfEnterpriseTermRevision"] !== undefined) {
        output["Count"] = 0;

        let results: any[] = [];

        if ("EnterpriseTermRevision" in input["PlatformMessage"]["ListOfEnterpriseTermRevision"]) {
            let termNode = input["PlatformMessage"]["ListOfEnterpriseTermRevision"]["EnterpriseTermRevision"];
            let terms = Array.isArray(termNode) ? termNode : [termNode];

            for (let i = 0; i < terms.length; i++) {
                let term = terms[i];
                if (!("ListOfTermSynonym" in term)) continue;

                let synonymNode = term["ListOfTermSynonym"]["TermSynonym"];
                let synonyms = Array.isArray(synonymNode) ? synonymNode : [synonymNode];

                for (let j = 0; j < synonyms.length; j++) {
                    let synonym: any = synonyms[j];
                    let row: any = {};

                    row.RowNum = j;
                    row.RowSelected = false;

                    row.USID = synonym.USID;
                    row.TermUSID = synonym.TermUSID;
                    row.SynonymTermUSID = synonym.SynonymTermUSID;
                    row.SynonymTermName = synonym.SynonymTermName;
                    row.Realm = synonym.Realm;
                    row.CreatedDatetime = synonym.CreatedDatetime;
                    row.Action = null;

                    row["__operation"] = "query results";

                    results.push(row);
                }
                output["Count"] = term["ListOfTermSynonym"].Count === undefined ? 0 : term["ListOfTermSynonym"].Count;
            }
        }

        output["Results"] = results;
    }

    return output;
};

// Classifications nested under the first matched EnterpriseTermRevision: drills
// ListOfEnterpriseTermRevision.EnterpriseTermRevision[0].ListOfTermClassification.TermClassification.
export const V1TermClassificationIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["PlatformMessage"] && input["PlatformMessage"]["ListOfEnterpriseTermRevision"] !== undefined) {
        output["Count"] = 0;

        let results: any[] = [];

        if ("EnterpriseTermRevision" in input["PlatformMessage"]["ListOfEnterpriseTermRevision"]) {
            let termNode = input["PlatformMessage"]["ListOfEnterpriseTermRevision"]["EnterpriseTermRevision"];
            let terms = Array.isArray(termNode) ? termNode : [termNode];

            for (let i = 0; i < terms.length; i++) {
                let term = terms[i];
                if (!("ListOfTermClassification" in term)) continue;

                let classificationNode = term["ListOfTermClassification"]["TermClassification"];
                let classifications = Array.isArray(classificationNode) ? classificationNode : [classificationNode];

                for (let j = 0; j < classifications.length; j++) {
                    let classification: any = classifications[j];
                    let row: any = {};

                    row.RowNum = j;
                    row.RowSelected = false;

                    row.USID = classification.USID;
                    row.TermUSID = classification.TermUSID;
                    row.Classification = classification.Classification;
                    row.Realm = classification.Realm;
                    row.CreatedDatetime = classification.CreatedDatetime;
                    row.Action = null;

                    row["__operation"] = "query results";

                    results.push(row);
                }
                output["Count"] = term["ListOfTermClassification"].Count === undefined ? 0 : term["ListOfTermClassification"].Count;
            }
        }

        output["Results"] = results;
    }

    return output;
};

export const V1DocumentTypeIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["PlatformMessage"]["ListOfDocumentType"] !== undefined) {
        if (input["PlatformMessage"]["ListOfDocumentType"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input["PlatformMessage"]["ListOfDocumentType"].Count;
        }

        let results = [];

        if ("DocumentType" in input["PlatformMessage"]["ListOfDocumentType"]) {
            for (let i = 0; i < input["PlatformMessage"]["ListOfDocumentType"]["DocumentType"].length; i++) {
                let documentType = input["PlatformMessage"]["ListOfDocumentType"]["DocumentType"][i];

                let row: any = {};

                row.USID = documentType.USID;
                row.DocumentTypeName = documentType.DocumentTypeName;
                row.DocumentTypeAcronym = documentType.DocumentTypeAcronym;
                row.ListOfFormTemplate = documentType.ListOfFormTemplate;
                row.Group = documentType.Group;

                row["__operation"] = "query results";

                results.push(row);
            }
        }
        output["Results"] = results;
    }
    return output;
};

export const V1DocumentTypeFormIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["PlatformMessage"]["ListOfDocumentType"] !== undefined) {
        if (input["PlatformMessage"]["ListOfDocumentType"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input["PlatformMessage"]["ListOfDocumentType"].Count;
        }

        let results = [];

        if ("DocumentType" in input["PlatformMessage"]["ListOfDocumentType"]) {
            for (let i = 0; i < input["PlatformMessage"]["ListOfDocumentType"]["DocumentType"].length; i++) {
                let documentType = input["PlatformMessage"]["ListOfDocumentType"]["DocumentType"][i];

                let row: any = {};

                row.USID = documentType.USID;
                row.DocumentTypeName = documentType.DocumentTypeName;
                row.DocumentTypeAcronym = documentType.DocumentTypeAcronym;
                row.ListOfFormTemplate = documentType.ListOfFormTemplate;
                row.Group = documentType.Group;

                row["__operation"] = "query results";

                results.push(row);
            }
        }
        output["Results"] = results;
    }
    return output;
};

export const V1DocumentTypeForm2IDOCToArray = (input: any) => {
    let output: any = {};

    if (input["PlatformMessage"]["ListOfDocumentType"] !== undefined) {
        if (input["PlatformMessage"]["ListOfDocumentType"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input["PlatformMessage"]["ListOfDocumentType"].Count;
        }

        let results = [];

        if ("DocumentType" in input["PlatformMessage"]["ListOfDocumentType"]) {
            for (let i = 0; i < input["PlatformMessage"]["ListOfDocumentType"]["DocumentType"].length; i++) {
                let documentType = input["PlatformMessage"]["ListOfDocumentType"]["DocumentType"][i];

                for (let j = 0; j < documentType["ListOfFormTemplate"]["FormTemplate"].length; j++) {
                    let formTemplate = documentType["ListOfFormTemplate"]["FormTemplate"][j];

                    let row: any = {};

                    row.USID = formTemplate.USID;
                    row.DocumentTypeUSID = documentType.USID;
                    row.Schema = formTemplate.Schema;
                    row.SchemaTemplate = formTemplate.SchemaTemplate;
                    row.FormDocumentRevisionUSID = formTemplate.DocumentRevision.USID;
                    row.FormDocumentRevisionDocumentID = formTemplate.DocumentRevision.DocumentID;
                    row.FormDocumentRevisionDocumentIDPlusRevision = formTemplate.DocumentRevision.DocumentID + " Rev " + formTemplate.DocumentRevision.DisplayRevision;
                    row.FormDocumentRevisionDisplayRevision = formTemplate.DocumentRevision.DisplayRevision;
                    row.FormInputTemplate = null
                    row.FormInputTemplateString = null
                    if (formTemplate.FormInputTemplate !== null && formTemplate.FormInputTemplate !== undefined) {
                        row.FormInputTemplate = JSON.parse(atob(formTemplate.FormInputTemplate));
                        row.FormInputTemplateString = JSON.stringify(JSON.parse(atob(formTemplate.FormInputTemplate)), null, 4);
                    }
                    row.FormDocumentRevisionStatus = formTemplate.DocumentRevision.Status;

                    row["__operation"] = "query results";
                    results.push(row);
                }
                if (documentType["ListOfFormTemplate"].Count === undefined) {
                    output["Count"] = 0;
                } else {
                    output["Count"] = documentType["ListOfFormTemplate"].Count;
                }
            }
        }
        output["Results"] = results;
    }
    return output;
};

export const V1DeveloperApplicationIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["PlatformMessage"]["ListOfDeveloperApplication"] !== undefined) {
        if (input["PlatformMessage"]["ListOfDeveloperApplication"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input["PlatformMessage"]["ListOfDeveloperApplication"].Count;
        }

        let results = [];

        if ("DeveloperApplication" in input["PlatformMessage"]["ListOfDeveloperApplication"]) {
            for (let i = 0; i < input["PlatformMessage"]["ListOfDeveloperApplication"]["DeveloperApplication"].length; i++) {
                let developerApplication = input["PlatformMessage"]["ListOfDeveloperApplication"]["DeveloperApplication"][i];

                let row: any = {};

                row.RowSelected = false;
                row.USID = developerApplication.USID;
                row.Name = developerApplication.Name;
                row.Status = null;
                row.Environment = developerApplication.Environment;
                row.AccountUserUSID = developerApplication.AccountUserUSID;
                row.UserUSID = developerApplication.UserUSID;
                row.AccountUserEmail = developerApplication.AccountUserEmail;
                row.AccountUserName = developerApplication.AccountUserName;
                row.Active = developerApplication.Active;
                row.DeactivationDatetime = developerApplication.DeactivationDatetime;
                row.CreatedDatetime = developerApplication.CreatedDatetime;
                row.LastModifiedDatetime = developerApplication.LastModifiedDatetime;
                row.Action = null;

                row["__operation"] = "query results";

                results.push(row);
            }
        }

        output["Results"] = results;
    }
    return output;
};

export const V1DeveloperCredentialIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["PlatformMessage"]["ListOfDeveloperCredential"] !== undefined) {
        if (input["PlatformMessage"]["ListOfDeveloperCredential"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input["PlatformMessage"]["ListOfDeveloperCredential"].Count;
        }

        let results = [];

        if ("DeveloperCredential" in input["PlatformMessage"]["ListOfDeveloperCredential"]) {
            for (let i = 0; i < input["PlatformMessage"]["ListOfDeveloperCredential"]["DeveloperCredential"].length; i++) {
                let developerCredential = input["PlatformMessage"]["ListOfDeveloperCredential"]["DeveloperCredential"][i];

                let row: any = {};

                row.RowSelected = false;
                row.USID = developerCredential.USID;
                row.ApplicationUSID = developerCredential.ApplicationUSID;
                row.ApplicationName = developerCredential.ApplicationName;
                row.APIKey = developerCredential.APIKey;
                row.SecretKey = developerCredential.SecretKey;
                row.Active = developerCredential.Active;
                row.DeactivationDatetime = developerCredential.DeactivationDatetime;
                row.Status = null;
                row.CreatedDatetime = developerCredential.CreatedDatetime;
                row.LastModifiedDatetime = developerCredential.LastModifiedDatetime;
                row.Action = null;

                row["__operation"] = "query results";

                results.push(row);
            }
        }

        output["Results"] = results;
    }
    return output;
}

export const V1DeveloperCredentialAuthorizationIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["PlatformMessage"]["ListOfDeveloperCredentialAuthorization"] !== undefined) {
        if (input["PlatformMessage"]["ListOfDeveloperCredentialAuthorization"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input["PlatformMessage"]["ListOfDeveloperCredentialAuthorization"].Count;
        }

        let results = [];

        if ("DeveloperCredentialAuthorization" in input["PlatformMessage"]["ListOfDeveloperCredentialAuthorization"]) {
            for (let i = 0; i < input["PlatformMessage"]["ListOfDeveloperCredentialAuthorization"]["DeveloperCredentialAuthorization"].length; i++) {
                let developerCredentialAuthorization = input["PlatformMessage"]["ListOfDeveloperCredentialAuthorization"]["DeveloperCredentialAuthorization"][i];

                let row: any = {};

                row.RowSelected = false;
                row.USID = developerCredentialAuthorization.USID;
                row.CredentialUSID = developerCredentialAuthorization.CredentialUSID;
                row.Entity = developerCredentialAuthorization.Entity;
                row.ReadPermission = developerCredentialAuthorization.ReadPermission;
                row.CreatePermission = developerCredentialAuthorization.CreatePermission;
                row.UpdatePermission = developerCredentialAuthorization.UpdatePermission;
                row.DeletePermission = developerCredentialAuthorization.DeletePermission;
                row.CreatedDatetime = developerCredentialAuthorization.CreatedDatetime;
                row.LastModifiedDatetime = developerCredentialAuthorization.LastModifiedDatetime;

                row["__operation"] = "query results";

                results.push(row);
            }
        }

        output["Results"] = results;
    }
    return output;
}

export const V1DeveloperCredentialAuthorizationDetailIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["PlatformMessage"]["ListOfDeveloperCredentialAuthorizationDetail"] !== undefined) {
        if (input["PlatformMessage"]["ListOfDeveloperCredentialAuthorizationDetail"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input["PlatformMessage"]["ListOfDeveloperCredentialAuthorizationDetail"].Count;
        }

        let results = [];

        if ("DeveloperCredentialAuthorizationDetail" in input["PlatformMessage"]["ListOfDeveloperCredentialAuthorizationDetail"]) {
            for (let i = 0; i < input["PlatformMessage"]["ListOfDeveloperCredentialAuthorizationDetail"]["DeveloperCredentialAuthorizationDetail"].length; i++) {
                let developerCredentialAuthorizationDetail = input["PlatformMessage"]["ListOfDeveloperCredentialAuthorizationDetail"]["DeveloperCredentialAuthorizationDetail"][i];

                let row: any = {};

                row.RowSelected = false;
                row.USID = developerCredentialAuthorizationDetail.USID;
                row.AuthorizationUSID = developerCredentialAuthorizationDetail.AuthorizationUSID;
                row.IDOC = developerCredentialAuthorizationDetail.IDOC;
                row.Active = developerCredentialAuthorizationDetail.Active;
                row.CreatedDatetime = developerCredentialAuthorizationDetail.CreatedDatetime;
                row.LastModifiedDatetime = developerCredentialAuthorizationDetail.LastModifiedDatetime;

                row["__operation"] = "query results";

                results.push(row);
            }
        }

        output["Results"] = results;
    }
    return output;
}

export const V1ServiceCatalogIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["PlatformMessage"]["ListOfServiceCatalog"] !== undefined) {
        if (input["PlatformMessage"]["ListOfServiceCatalog"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input["PlatformMessage"]["ListOfServiceCatalog"].Count;
        }

        let results = [];

        if ("ServiceCatalog" in input["PlatformMessage"]["ListOfServiceCatalog"]) {
            for (let i = 0; i < input["PlatformMessage"]["ListOfServiceCatalog"]["ServiceCatalog"].length; i++) {
                let serviceCatalog = input["PlatformMessage"]["ListOfServiceCatalog"]["ServiceCatalog"][i];

                let row: any = {};

                row.RowSelected = false;
                row.USID = serviceCatalog.USID;
                row.Name = serviceCatalog.Name;
                row.Classification = serviceCatalog.Classification;
                row.Subclassification = serviceCatalog.Subclassification;
                row.CreatedDatetime = serviceCatalog.CreatedDatetime;
                row.LastModifiedDatetime = serviceCatalog.LastModifiedDatetime;

                row["__operation"] = "query results";

                results.push(row);
            }
        }

        output["Results"] = results;
    }
    return output;
}

export const V1ServiceCatalogConfigurationIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["PlatformMessage"]["ListOfServiceCatalogConfiguration"] !== undefined) {
        if (input["PlatformMessage"]["ListOfServiceCatalogConfiguration"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input["PlatformMessage"]["ListOfServiceCatalogConfiguration"].Count;
        }

        let results = [];

        if ("ServiceCatalogConfiguration" in input["PlatformMessage"]["ListOfServiceCatalogConfiguration"]) {
            for (let i = 0; i < input["PlatformMessage"]["ListOfServiceCatalogConfiguration"]["ServiceCatalogConfiguration"].length; i++) {
                let serviceCatalogConfiguration = input["PlatformMessage"]["ListOfServiceCatalogConfiguration"]["ServiceCatalogConfiguration"][i];

                let row: any = {};

                row.RowSelected = false;
                row.USID = serviceCatalogConfiguration.USID;
                row.ServiceCatalogUSID = serviceCatalogConfiguration.ServiceCatalogUSID;
                row.ConfigurationName = serviceCatalogConfiguration.ConfigurationName;
                row.ConfigurationDatatype = serviceCatalogConfiguration.ConfigurationDatatype;
                row.ConfigurationDefault = serviceCatalogConfiguration.ConfigurationDefault;
                row.CreatedDatetime = serviceCatalogConfiguration.CreatedDatetime;
                row.LastModifiedDatetime = serviceCatalogConfiguration.LastModifiedDatetime;

                row["__operation"] = "query results";

                results.push(row);
            }
        }

        output["Results"] = results;
    }
    return output;
}

export const V1DeveloperWorkflowExecutionIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["PlatformMessage"]["ListOfDeveloperWorkflowExecution"] !== undefined) {
        if (input["PlatformMessage"]["ListOfDeveloperWorkflowExecution"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input["PlatformMessage"]["ListOfDeveloperWorkflowExecution"].Count;
        }

        let results = [];

        if ("DeveloperWorkflowExecution" in input["PlatformMessage"]["ListOfDeveloperWorkflowExecution"]) {
            for (let i = 0; i < input["PlatformMessage"]["ListOfDeveloperWorkflowExecution"]["DeveloperWorkflowExecution"].length; i++) {
                let execution = input["PlatformMessage"]["ListOfDeveloperWorkflowExecution"]["DeveloperWorkflowExecution"][i];

                let row: any = {};

                row.RowSelected = false;
                row.USID = execution.USID;
                row.WorkflowUSID = execution.WorkflowUSID;
                row.Status = execution.Status;
                row.Input = execution.Input;
                row.Output = execution.Output;
                row.CurrentStateName = execution.CurrentStateName;
                row.Trace = execution.Trace;
                row.StartedDatetime = execution.StartedDatetime;
                row.CompletedDatetime = execution.CompletedDatetime;
                row.Action = null;

                row["__operation"] = "query results";

                results.push(row);
            }
        }

        output["Results"] = results;
    }
    return output;
}

export const V1DeveloperWorkflowIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["PlatformMessage"]["ListOfDeveloperWorkflow"] !== undefined) {
        if (input["PlatformMessage"]["ListOfDeveloperWorkflow"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input["PlatformMessage"]["ListOfDeveloperWorkflow"].Count;
        }

        let results = [];

        if ("DeveloperWorkflow" in input["PlatformMessage"]["ListOfDeveloperWorkflow"]) {
            for (let i = 0; i < input["PlatformMessage"]["ListOfDeveloperWorkflow"]["DeveloperWorkflow"].length; i++) {
                let developerWorkflow = input["PlatformMessage"]["ListOfDeveloperWorkflow"]["DeveloperWorkflow"][i];

                let row: any = {};

                row.RowSelected = false;
                row.USID = developerWorkflow.USID;
                row.Name = developerWorkflow.Name;
                row.Description = developerWorkflow.Description;
                // Schema is a JSON column on the backend. Depending on the
                // IDOC serializer it may arrive as a parsed object or as a
                // JSON-encoded string; the consumer (DashboardWorkflowEditor)
                // handles both.
                row.Schema = developerWorkflow.Schema;
                row.Status = developerWorkflow.Status;
                row.CreatedDatetime = developerWorkflow.CreatedDatetime;
                row.LastModifiedDatetime = developerWorkflow.LastModifiedDatetime;
                row.Action = null;

                row["__operation"] = "query results";

                results.push(row);
            }
        }

        output["Results"] = results;
    }
    return output;
}

export const V1DeveloperEventIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["PlatformMessage"]["ListOfDeveloperEvent"] !== undefined) {
        if (input["PlatformMessage"]["ListOfDeveloperEvent"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input["PlatformMessage"]["ListOfDeveloperEvent"].Count;
        }

        let results = [];

        if ("DeveloperEvent" in input["PlatformMessage"]["ListOfDeveloperEvent"]) {
            for (let i = 0; i < input["PlatformMessage"]["ListOfDeveloperEvent"]["DeveloperEvent"].length; i++) {
                let developerEvent = input["PlatformMessage"]["ListOfDeveloperEvent"]["DeveloperEvent"][i];

                let row: any = {};

                row.RowSelected = false;
                row.USID = developerEvent.USID;
                row.ServiceCatalogUSID = developerEvent.ServiceCatalogUSID;
                row.ServiceName = developerEvent.ServiceName;
                row.EventType = developerEvent.EventType;
                row.CreatedDatetime = developerEvent.CreatedDatetime;
                row.LastModifiedDatetime = developerEvent.LastModifiedDatetime;

                row["__operation"] = "query results";

                results.push(row);
            }
        }

        output["Results"] = results;
    }
    return output;
}

export const V1DeveloperEventConfigurationIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["PlatformMessage"]["ListOfDeveloperEventConfiguration"] !== undefined) {
        if (input["PlatformMessage"]["ListOfDeveloperEventConfiguration"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input["PlatformMessage"]["ListOfDeveloperEventConfiguration"].Count;
        }

        let results = [];

        if ("DeveloperEventConfiguration" in input["PlatformMessage"]["ListOfDeveloperEventConfiguration"]) {
            for (let i = 0; i < input["PlatformMessage"]["ListOfDeveloperEventConfiguration"]["DeveloperEventConfiguration"].length; i++) {
                let developerEventConfiguration = input["PlatformMessage"]["ListOfDeveloperEventConfiguration"]["DeveloperEventConfiguration"][i];

                let row: any = {};

                row.RowSelected = false;
                row.USID = developerEventConfiguration.USID;
                row.DeveloperEventUSID = developerEventConfiguration.DeveloperEventUSID;
                row.ConfigurationName = developerEventConfiguration.ConfigurationName;
                row.ConfigurationValue = developerEventConfiguration.ConfigurationValue;
                row.CreatedDatetime = developerEventConfiguration.CreatedDatetime;
                row.LastModifiedDatetime = developerEventConfiguration.LastModifiedDatetime;

                row["__operation"] = "query results";

                results.push(row);
            }
        }

        output["Results"] = results;
    }
    return output;
}

export const V1AccountUserIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["PlatformMessage"]["ListOfAccountUser"] !== undefined) {
        if (input["PlatformMessage"]["ListOfAccountUser"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input["PlatformMessage"]["ListOfAccountUser"].Count;
        }

        let results = [];

        if ("AccountUser" in input["PlatformMessage"]["ListOfAccountUser"]) {
            for (let i = 0; i < input["PlatformMessage"]["ListOfAccountUser"]["AccountUser"].length; i++) {
                let accountUser = input["PlatformMessage"]["ListOfAccountUser"]["AccountUser"][i];

                if (accountUser.Active === false || accountUser.Locked === true) {
                    continue
                }

                let row: any = {};

                row.RowSelected = false;
                row.USID = accountUser.USID;
                row.UserUSID = accountUser.UserUSID;
                row.Email = accountUser.Email;
                row.Name = accountUser.Name;
                row.Confirmed = accountUser.Confirmed;
                row.Locked = accountUser.Locked;
                row.UserStatus = accountUser.UserStatus;
                row.EmailVerificationState = accountUser.EmailVerificationState;
                row.EmailVerificationDatetime = accountUser.EmailVerificationDatetime;
                row.CreatedDatetime = accountUser.CreatedDatetime;
                row.LastModifiedDatetime = accountUser.LastModifiedDatetime;
                row.Action = null;

                row["__operation"] = "query results";

                results.push(row);
            }
        }

        output["Results"] = results;
    }
    return output;
};

export const V1OrganizationIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["PlatformMessage"] && input["PlatformMessage"] && input.PlatformMessage["ListOfOrganization"] !== undefined) {
        if (input.PlatformMessage["ListOfOrganization"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input.PlatformMessage["ListOfOrganization"].Count;
        }

        let results: any[] = [];

        if ("Organization" in input.PlatformMessage["ListOfOrganization"]) {
            for (let i = 0; i < input.PlatformMessage["ListOfOrganization"]["Organization"].length; i++) {
                let organization = input.PlatformMessage["ListOfOrganization"]["Organization"][i];
                let row: any = {};

                row.RowNum = i;
                row.RowSelected = false;

                row.USID = organization.USID;
                row.ParentUSID = organization.ParentUSID;
                row.ParentOrganizationName = organization.ParentOrganizationName;
                row.OrganizationType = organization.OrganizationType;
                row.Name = organization.Name;
                row.Status = organization.Status;

                row.CreatedDatetime = organization.CreatedDatetime;
                row.LastModifiedDatetime = organization.LastModifiedDatetime;
                row.Keyword = organization.Keyword;
                row.Realm = organization.Realm;

                row["__operation"] = "query results";

                results.push(row);
            }
        }
        output["Results"] = results;
    }

    return output;
};

// Ported from t1 unchanged. The organisation chart reads POSITIONS GROUPED BY ORGANISATION
// -- t6 returns them nested, one ListOfPosition inside each Organization, and the chart wants
// them flat with the organisation named on every row.
export const V1OrganizationPositionIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["PlatformMessage"] && input.PlatformMessage["ListOfOrganization"] !== undefined) {
        if (input.PlatformMessage["ListOfOrganization"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input.PlatformMessage["ListOfOrganization"].Count;
        }

        let results: any[] = [];

        if ("Organization" in input.PlatformMessage["ListOfOrganization"]) {
            for (let i = 0; i < input.PlatformMessage["ListOfOrganization"]["Organization"].length; i++) {
                let organization = input.PlatformMessage["ListOfOrganization"]["Organization"][i];

                for (let j = 0; j < organization["ListOfPosition"]["Position"].length; j++) {
                    let position: any = organization["ListOfPosition"]["Position"][j];

                    let row: any = {};

                    row.RowSelected = false;
                    row.USID = position.USID;
                    row.ParentUSID = position.ParentUSID;
                    row.ParentPositionName = position.ParentPositionName;
                    row.PrimaryAccountUserUSID = position.PrimaryAccountUserUSID;
                    row.PrimaryAccountUserName = position.PrimaryAccountUserName;
                    row.OrganizationUSID = position.OrganizationUSID;
                    row.OrganizationName = position.OrganizationName;
                    row.Name = position.Name;
                    row.Status = position.Status;
                    row.CreatedDatetime = position.CreatedDatetime;
                    row.LastModifiedDatetime = position.LastModifiedDatetime;
                    row.Action = null;

                    row["__operation"] = "query results";

                    results.push(row);
                }
                if (organization["ListOfPosition"].Count === undefined) {
                    output["Count"] = 0;
                } else {
                    output["Count"] = organization["ListOfPosition"].Count;
                }
            }
        }
        output["Results"] = results;
    }
    return output;
};

export const V1PositionIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["PlatformMessage"]["ListOfPosition"] !== undefined) {
        output["Count"] = input["PlatformMessage"]["ListOfPosition"].Count ?? 0;

        let results = [];

        if ("Position" in input["PlatformMessage"]["ListOfPosition"]) {
            for (let i = 0; i < input["PlatformMessage"]["ListOfPosition"]["Position"].length; i++) {
                let position = input["PlatformMessage"]["ListOfPosition"]["Position"][i];

                let row: any = {};

                row.RowSelected = false;
                row.USID = position.USID;
                row.Name = position.Name;
                row.OrganizationUSID = position.OrganizationUSID;
                row.ParentUSID = position.ParentUSID;
                row.PrimaryAccountUserName = position.PrimaryAccountUserName;
                // The account users holding this position, present only when the caller asked for
                // v1.Position-002. The Visibility tab reads it to list the primary position's
                // membership beside the shared positions', which is what the enlil-t8 Project Plan
                // detail this was ported from does.
                row.AccountUsers = _asArray(position.ListOfAccountUser ? position.ListOfAccountUser.AccountUser : null);
                row.Status = position.Status;
                row.CreatedDatetime = position.CreatedDatetime;
                row.Action = null;

                row["__operation"] = "query results";

                results.push(row);
            }
        }

        output["Results"] = results;
    }
    return output;
};

export const V1UserGroupIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["PlatformMessage"]["ListOfUserGroup"] !== undefined) {
        output["Count"] = input["PlatformMessage"]["ListOfUserGroup"].Count ?? 0;

        let results = [];

        if ("UserGroup" in input["PlatformMessage"]["ListOfUserGroup"]) {
            for (let i = 0; i < input["PlatformMessage"]["ListOfUserGroup"]["UserGroup"].length; i++) {
                let userGroup = input["PlatformMessage"]["ListOfUserGroup"]["UserGroup"][i];

                let row: any = {};

                row.RowSelected = false;
                row.USID = userGroup.USID;
                row.Name = userGroup.Name;
                // The account users in this group, present only when the caller asked for the -002
                // document. The Visibility tab reads it to show the primary group's membership.
                row.AccountUsers = _asArray(userGroup.ListOfAccountUser ? userGroup.ListOfAccountUser.AccountUser : null);
                row.Status = userGroup.Status;
                row.CreatedDatetime = userGroup.CreatedDatetime;
                row.Action = null;

                row["__operation"] = "query results";

                results.push(row);
            }
        }

        output["Results"] = results;
    }
    return output;
};

export const V1WorkGroupIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["PlatformMessage"]["ListOfWorkGroup"] !== undefined) {
        output["Count"] = input["PlatformMessage"]["ListOfWorkGroup"].Count ?? 0;

        let results = [];

        if ("WorkGroup" in input["PlatformMessage"]["ListOfWorkGroup"]) {
            for (let i = 0; i < input["PlatformMessage"]["ListOfWorkGroup"]["WorkGroup"].length; i++) {
                let workGroup = input["PlatformMessage"]["ListOfWorkGroup"]["WorkGroup"][i];

                let row: any = {};

                row.RowSelected = false;
                row.USID = workGroup.USID;
                row.Name = workGroup.Name;
                // The account users in this group, present only when the caller asked for the -002
                // document. The Visibility tab reads it to show the primary group's membership.
                row.AccountUsers = _asArray(workGroup.ListOfWorkGroupAccountUser ? workGroup.ListOfWorkGroupAccountUser.WorkGroupAccountUser : null);
                row.Status = workGroup.Status;
                row.CreatedDatetime = workGroup.CreatedDatetime;
                row.Action = null;

                row["__operation"] = "query results";

                results.push(row);
            }
        }

        output["Results"] = results;
    }
    return output;
};

export const V1DeveloperExceptionIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["PlatformMessage"]["ListOfDeveloperException"] !== undefined) {
        if (input["PlatformMessage"]["ListOfDeveloperException"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input["PlatformMessage"]["ListOfDeveloperException"].Count;
        }

        let results = [];
        if ("DeveloperException" in input["PlatformMessage"]["ListOfDeveloperException"]) {
            for (let i = 0; i < input["PlatformMessage"]["ListOfDeveloperException"]["DeveloperException"].length; i++) {
                let developerException = input["PlatformMessage"]["ListOfDeveloperException"]["DeveloperException"][i];

                let row: any = {};

                let unordered = JSON.parse(atob(developerException.Payload));
                const ordered = Object.keys(unordered).sort().reduce(
                    (obj: any, key: string) => {
                        obj[key] = unordered[key];
                        return obj;
                    },
                    {}
                );

                row.RowSelected = false;
                row.USID = developerException.USID;
                row.EventID = developerException.EventID;
                row.CreatedDatetime = developerException.CreatedDatetime;
                row.EventType = developerException.EventType;
                row.ExceptionPayload = ordered
                row.LastModifiedDatetime = developerException.LastModifiedDatetime;
                row.Action = null;

                row["__operation"] = "query results";

                results.push(row);
            }
        }

        output["Results"] = results;
    }
    return output;
};

export const V1DeveloperLogIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["PlatformMessage"]["ListOfDeveloperLog"] !== undefined) {
        if (input["PlatformMessage"]["ListOfDeveloperLog"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input["PlatformMessage"]["ListOfDeveloperLog"].Count;
        }

        let results = [];

        if ("DeveloperLog" in input["PlatformMessage"]["ListOfDeveloperLog"]) {
            for (let i = 0; i < input["PlatformMessage"]["ListOfDeveloperLog"]["DeveloperLog"].length; i++) {
                let developerLog = input["PlatformMessage"]["ListOfDeveloperLog"]["DeveloperLog"][i];

                let row: any = {};

                row.RowSelected = false;
                row.USID = developerLog.USID;
                row.EventCode = developerLog.EventID;
                row.CreatedDatetime = developerLog.CreatedDatetime;
                row.EventType = developerLog.EventType;
                row.EventPayload = developerLog.Payload;
                row.EventPayloadJSON = null;
                if (developerLog.Payload !== null) {
                    row.EventPayloadJSON = JSON.parse(atob(developerLog.Payload));
                }
                row.Action = null;

                row["__operation"] = "query results";

                results.push(row);
            }
        }

        output["Results"] = results;
    }
    return output;
};

export const V1BillConfigurationIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["PlatformMessage"]["ListOfBillConfiguration"] !== undefined) {
        if (input["PlatformMessage"]["ListOfBillConfiguration"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input["PlatformMessage"]["ListOfBillConfiguration"].Count;
        }

        let results = [];

        if ("BillConfiguration" in input["PlatformMessage"]["ListOfBillConfiguration"]) {
            for (let i = 0; i < input["PlatformMessage"]["ListOfBillConfiguration"]["BillConfiguration"].length; i++) {
                let billConfiguration = input["PlatformMessage"]["ListOfBillConfiguration"]["BillConfiguration"][i];

                let row: any = {};

                row.RowSelected = false;
                row.USID = billConfiguration.USID;
                row.UserName = billConfiguration.UserName;
                row.Password = billConfiguration.Password;
                row.V2APIUrl = billConfiguration.V2APIUrl;
                row.V3APIUrl = billConfiguration.V3APIUrl;
                row.DeveloperKey = billConfiguration.DeveloperKey;
                row.OrganizationID = billConfiguration.OrganizationID;
                row.CreatedDatetime = billConfiguration.CreatedDatetime;
                row.LastModifiedDatetime = billConfiguration.LastModifiedDatetime;

                row["__operation"] = "query results";

                results.push(row);
            }
        }

        output["Results"] = results;
    }
    return output;
};

export const V1BillSubscriptionIDOCToArray = (input: any) => {
    let output: any = {};

    if (input.PlatformMessage["ListOfBillConfiguration"] !== undefined) {
        if (input.PlatformMessage["ListOfBillConfiguration"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input.PlatformMessage["ListOfBillConfiguration"].Count;
        }

        let results: any[] = [];

        if ("BillConfiguration" in input.PlatformMessage["ListOfBillConfiguration"]) {
            for (let i = 0; i < input.PlatformMessage["ListOfBillConfiguration"]["BillConfiguration"].length; i++) {
                let billConfiguration = input.PlatformMessage["ListOfBillConfiguration"]["BillConfiguration"][i];

                for (let j = 0; j < billConfiguration["ListOfBillSubscription"]["BillSubscription"].length; j++) {
                    let billSubscription: any = billConfiguration["ListOfBillSubscription"]["BillSubscription"][j];

                    let row: any = {};

                    row.RowSelected = false;
                    row.USID = billSubscription.USID;
                    row.Name = billSubscription.Name;
                    row.BillConfigurationUSID = billSubscription.BillConfigurationUSID;
                    row.Status = billSubscription.Status;
                    row.EventType = billSubscription.EventType;
                    row.EventVersion = billSubscription.EventVersion;
                    row.SubscriptionID = billSubscription.SubscriptionID;
                    row.SecurityKey = billSubscription.SecurityKey;
                    row.CreatedDatetime = billSubscription.CreatedDatetime;
                    row.LastModifiedDatetime = billSubscription.LastModifiedDatetime;
                    row.Action = null;

                    row["__operation"] = "query results";

                    results.push(row);
                }
                if (billConfiguration["ListOfBillSubscription"].Count === undefined) {
                    output["Count"] = 0;
                } else {
                    output["Count"] = billConfiguration["ListOfBillSubscription"].Count;
                }
            }
        }
        output["Results"] = results;
    }
    return output;
};

export const V1BillSubscriptionCommunicationIDOCToArray = (input: any) => {
    let output: any = {};

    if (input.PlatformMessage["ListOfBillConfiguration"] !== undefined) {
        if (input.PlatformMessage["ListOfBillConfiguration"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input.PlatformMessage["ListOfBillConfiguration"].Count;
        }

        let results: any[] = [];

        if ("BillConfiguration" in input.PlatformMessage["ListOfBillConfiguration"]) {
            for (let i = 0; i < input.PlatformMessage["ListOfBillConfiguration"]["BillConfiguration"].length; i++) {
                let billConfiguration = input.PlatformMessage["ListOfBillConfiguration"]["BillConfiguration"][i];

                for (let j = 0; j < billConfiguration["ListOfBillSubscription"]["BillSubscription"].length; j++) {
                    let billSubscription: any = billConfiguration["ListOfBillSubscription"]["BillSubscription"][j];

                    for (let k = 0; k < billSubscription["ListOfBillSubscriptionCommunication"]["BillSubscriptionCommunication"].length; k++) {
                        let billSubscriptionCommunication = billSubscription["ListOfBillSubscriptionCommunication"]["BillSubscriptionCommunication"][k];

                        let row: any = {};

                        row.RowSelected = false;
                        row.USID = billSubscriptionCommunication.USID;
                        row.PayloadJSON = JSON.parse(atob(billSubscriptionCommunication.Payload));
                        row.PayloadString = JSON.stringify(JSON.parse(atob(billSubscriptionCommunication.Payload)));
                        row.BillSubscriptionUSID = billSubscriptionCommunication.BillSubscriptionUSID;
                        row.CreatedDatetime = billSubscriptionCommunication.CreatedDatetime;
                        row.LastModifiedDatetime = billSubscriptionCommunication.LastModifiedDatetime;
                        row.Action = null;

                        row["__operation"] = "query results";

                        results.push(row);
                    }
                    if (billSubscription["ListOfBillSubscriptionCommunication"].Count === undefined) {
                        output["Count"] = 0;
                    } else {
                        output["Count"] = billSubscription["ListOfBillSubscriptionCommunication"].Count;
                    }
                }
            }
        }
        output["Results"] = results;
    }
    return output;
};

export const V1DeveloperSubscriptionIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["PlatformMessage"]["ListOfDeveloperSubscription"] !== undefined) {
        if (input["PlatformMessage"]["ListOfDeveloperSubscription"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input["PlatformMessage"]["ListOfDeveloperSubscription"].Count;
        }

        let results = [];
        if ("DeveloperSubscription" in input["PlatformMessage"]["ListOfDeveloperSubscription"]) {
            for (let i = 0; i < input["PlatformMessage"]["ListOfDeveloperSubscription"]["DeveloperSubscription"].length; i++) {
                let developerSubscription = input["PlatformMessage"]["ListOfDeveloperSubscription"]["DeveloperSubscription"][i];

                let row: any = {};

                row.RowSelected = false;
                row.USID = developerSubscription.USID;
                row.Name = developerSubscription.Name;
                row.Status = developerSubscription.Status;
                row.SecurityKey = developerSubscription.SecurityKey;
                row.NotificationURL = developerSubscription.NotificationURL;
                row.EventType = developerSubscription.EventType;
                row.CreatedDatetime = developerSubscription.CreatedDatetime;
                row.LastModifiedDatetime = developerSubscription.LastModifiedDatetime;
                row.Action = null;

                row["__operation"] = "query results";

                results.push(row);
            }
        }

        output["Results"] = results;
    }
    return output;
};

export const V1DeveloperSubscriptionCommunicationIDOCToArray = (input: any) => {
    let output: any = {};

    if (input.PlatformMessage["ListOfDeveloperSubscription"] !== undefined) {
        if (input.PlatformMessage["ListOfDeveloperSubscription"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input.PlatformMessage["ListOfDeveloperSubscription"].Count;
        }

        let results: any[] = [];

        if ("DeveloperSubscription" in input.PlatformMessage["ListOfDeveloperSubscription"]) {
            for (let i = 0; i < input.PlatformMessage["ListOfDeveloperSubscription"]["DeveloperSubscription"].length; i++) {
                let developerSubscription = input.PlatformMessage["ListOfDeveloperSubscription"]["DeveloperSubscription"][i];

                for (let k = 0; k < developerSubscription["ListOfDeveloperSubscriptionCommunication"]["DeveloperSubscriptionCommunication"].length; k++) {
                    let developerSubscriptionCommunication = developerSubscription["ListOfDeveloperSubscriptionCommunication"]["DeveloperSubscriptionCommunication"][k];

                    let row: any = {};

                    row.RowSelected = false;
                    row.USID = developerSubscriptionCommunication.USID;
                    row.PayloadJSON = JSON.parse(atob(developerSubscriptionCommunication.Payload));
                    row.PayloadString = JSON.stringify(JSON.parse(atob(developerSubscriptionCommunication.Payload)));
                    row.ResponseJSON = null;
                    if (developerSubscriptionCommunication.Response !== null) {
                        row.ResponseJSON = JSON.parse(atob(developerSubscriptionCommunication.Response));
                        row.ResponseString = JSON.stringify(JSON.parse(atob(developerSubscriptionCommunication.Response)));
                    }
                    row.BillSubscriptionUSID = developerSubscriptionCommunication.BillSubscriptionUSID;
                    row.CreatedDatetime = developerSubscriptionCommunication.CreatedDatetime;
                    row.LastModifiedDatetime = developerSubscriptionCommunication.LastModifiedDatetime;
                    row.Action = null;

                    row["__operation"] = "query results";

                    results.push(row);
                }
                if (developerSubscription["ListOfDeveloperSubscriptionCommunication"].Count === undefined) {
                    output["Count"] = 0;
                } else {
                    output["Count"] = developerSubscription["ListOfDeveloperSubscriptionCommunication"].Count;
                }
            }
        }
        output["Results"] = results;
    }
    return output;
};

export const V1DeveloperSandboxIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["PlatformMessage"]["ListOfDeveloperSandbox"] !== undefined) {
        if (input["PlatformMessage"]["ListOfDeveloperSandbox"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input["PlatformMessage"]["ListOfDeveloperSandbox"].Count;
        }

        let results = [];

        if ("DeveloperSandbox" in input["PlatformMessage"]["ListOfDeveloperSandbox"]) {
            for (let i = 0; i < input["PlatformMessage"]["ListOfDeveloperSandbox"]["DeveloperSandbox"].length; i++) {
                let sandbox = input["PlatformMessage"]["ListOfDeveloperSandbox"]["DeveloperSandbox"][i];

                let row: any = {};

                row.RowSelected = false;
                row.USID = sandbox.USID;
                row.Name = sandbox.Name;
                row.AWSAccount = sandbox.AWSAccount;
                row.AWSRegion = sandbox.AWSRegion;
                row.AssumeRoleARN = sandbox.AssumeRoleARN;
                row.SourceBucket = sandbox.SourceBucket;
                row.VPCCIDR = sandbox.VPCCIDR;
                row.AvailabilityZones = sandbox.AvailabilityZones;
                row.AuroraEngineVersion = sandbox.AuroraEngineVersion;
                row.AuroraInstanceClass = sandbox.AuroraInstanceClass;
                row.RedisNodeType = sandbox.RedisNodeType;
                row.Status = sandbox.Status;
                row.BatchJobID = sandbox.BatchJobID;
                row.BatchJobName = sandbox.BatchJobName;
                row.BatchJobStatus = sandbox.BatchJobStatus;
                row.BatchJobStatusReason = sandbox.BatchJobStatusReason;
                row.Outputs = sandbox.Outputs;
                row.URLs = sandbox.URLs;
                row.CreatedByUSID = sandbox.CreatedByUSID;
                row.DestroyedDatetime = sandbox.DestroyedDatetime;
                row.CreatedDatetime = sandbox.CreatedDatetime;
                row.LastModifiedDatetime = sandbox.LastModifiedDatetime;

                row["__operation"] = "query results";

                results.push(row);
            }
        }

        output["Results"] = results;
    }
    return output;
};

// ---------------------------------------------------------------------------
// Knowledge Catalog term visibility: Position / User Group / Work Group memberships.
// Generic associations keyed by SourceUSID + SourceType ("EnterpriseTermRevision").
// The -002 idoc response nests member AccountUsers; extract defensively regardless of
// whether the response node is a single object or an array.
// ---------------------------------------------------------------------------

const _asArray = (node: any): any[] => (node === undefined || node === null ? [] : (Array.isArray(node) ? node : [node]));

const _membershipAccountUsers = (membership: any): any[] => {
    // -002 shapes vary by entity: Position nests under a Position child, User/Work Group nest directly.
    if (membership.Position && membership.Position.ListOfAccountUser) return _asArray(membership.Position.ListOfAccountUser.AccountUser);
    if (membership.ListOfAccountUser) return _asArray(membership.ListOfAccountUser.AccountUser);
    if (membership.WorkGroup && membership.WorkGroup.ListOfAccountUser) return _asArray(membership.WorkGroup.ListOfAccountUser.AccountUser);
    return [];
};

// Capability list (t5/v1/capabilities, read-only) — backs the share-capability picker.
export const V1CapabilityIDOCToArray = (input: any) => {
    let output: any = {};
    if (input["PlatformMessage"] && input["PlatformMessage"]["ListOfCapability"] !== undefined) {
        output["Count"] = input["PlatformMessage"]["ListOfCapability"].Count === undefined ? 0 : input["PlatformMessage"]["ListOfCapability"].Count;
        let results: any[] = [];
        if ("Capability" in input["PlatformMessage"]["ListOfCapability"]) {
            let node = input["PlatformMessage"]["ListOfCapability"]["Capability"];
            let rows = Array.isArray(node) ? node : [node];
            for (let i = 0; i < rows.length; i++) {
                let c = rows[i];
                let row: any = {};
                row.RowNum = i;
                row.RowSelected = false;
                row.USID = c.USID;
                row.Name = c.Name;
                row.Description = c.Description;
                row.ObjectType = c.ObjectType;
                row.CreatedDatetime = c.CreatedDatetime;
                row.LastModifiedDatetime = c.LastModifiedDatetime;
                row.Realm = c.Realm;
                row["__operation"] = "query results";
                results.push(row);
            }
        }
        output["Results"] = results;
    }
    return output;
};

// A share's granted capabilities (t5/v1/membership_capabilities). MembershipUSID keys the row to a
// *_MEMBERSHIP share; CapabilityName/ObjectType ride along (LEFT-joined in the EC) for display.
export const V1MembershipCapabilityIDOCToArray = (input: any) => {
    let output: any = {};
    if (input["PlatformMessage"] && input["PlatformMessage"]["ListOfMembershipCapability"] !== undefined) {
        output["Count"] = input["PlatformMessage"]["ListOfMembershipCapability"].Count === undefined ? 0 : input["PlatformMessage"]["ListOfMembershipCapability"].Count;
        let results: any[] = [];
        if ("MembershipCapability" in input["PlatformMessage"]["ListOfMembershipCapability"]) {
            let node = input["PlatformMessage"]["ListOfMembershipCapability"]["MembershipCapability"];
            let rows = Array.isArray(node) ? node : [node];
            for (let i = 0; i < rows.length; i++) {
                let mc = rows[i];
                let row: any = {};
                row.RowNum = i;
                row.RowSelected = false;
                row.USID = mc.USID;
                row.MembershipUSID = mc.MembershipUSID;
                row.CapabilityUSID = mc.CapabilityUSID;
                row.CapabilityName = mc.CapabilityName;
                row.CapabilityObjectType = mc.CapabilityObjectType;
                row.CreatedDatetime = mc.CreatedDatetime;
                row.LastModifiedDatetime = mc.LastModifiedDatetime;
                row.Realm = mc.Realm;
                row["__operation"] = "query results";
                results.push(row);
            }
        }
        output["Results"] = results;
    }
    return output;
};

export const V1PositionMembershipIDOCToArray = (input: any) => {
    let output: any = {};
    if (input["PlatformMessage"] && input["PlatformMessage"]["ListOfPositionMembership"] !== undefined) {
        output["Count"] = input["PlatformMessage"]["ListOfPositionMembership"].Count === undefined ? 0 : input["PlatformMessage"]["ListOfPositionMembership"].Count;
        let results: any[] = [];
        if ("PositionMembership" in input["PlatformMessage"]["ListOfPositionMembership"]) {
            let rows = _asArray(input["PlatformMessage"]["ListOfPositionMembership"]["PositionMembership"]);
            for (let i = 0; i < rows.length; i++) {
                let m = rows[i];
                let row: any = {};
                row.RowNum = i;
                row.RowSelected = false;
                row.USID = m.USID;
                row.SourceUSID = m.SourceUSID;
                row.SourceType = m.SourceType;
                row.PositionUSID = m.PositionUSID;
                row.PositionName = m.PositionName;
                row.PrimaryAccountUserUSID = m.PrimaryAccountUserUSID;
                row.PrimaryAccountUserName = m.PrimaryAccountUserName;
                row.AccountUsers = _membershipAccountUsers(m);
                row.Realm = m.Realm;
                row.CreatedDatetime = m.CreatedDatetime;
                row.LastModifiedDatetime = m.LastModifiedDatetime;
                row["__operation"] = "query results";
                results.push(row);
            }
        }
        output["Results"] = results;
    }
    return output;
};

export const V1UserGroupMembershipIDOCToArray = (input: any) => {
    let output: any = {};
    if (input["PlatformMessage"] && input["PlatformMessage"]["ListOfUserGroupMembership"] !== undefined) {
        output["Count"] = input["PlatformMessage"]["ListOfUserGroupMembership"].Count === undefined ? 0 : input["PlatformMessage"]["ListOfUserGroupMembership"].Count;
        let results: any[] = [];
        if ("UserGroupMembership" in input["PlatformMessage"]["ListOfUserGroupMembership"]) {
            let rows = _asArray(input["PlatformMessage"]["ListOfUserGroupMembership"]["UserGroupMembership"]);
            for (let i = 0; i < rows.length; i++) {
                let m = rows[i];
                let row: any = {};
                row.RowNum = i;
                row.RowSelected = false;
                row.USID = m.USID;
                row.SourceUSID = m.SourceUSID;
                row.SourceType = m.SourceType;
                row.UserGroupUSID = m.UserGroupUSID;
                row.UserGroupName = m.UserGroupName;
                row.PrimaryAccountUserUSID = m.PrimaryAccountUserUSID;
                row.PrimaryAccountUserName = m.PrimaryAccountUserName;
                row.AccountUsers = _membershipAccountUsers(m);
                row.Realm = m.Realm;
                row.CreatedDatetime = m.CreatedDatetime;
                row.LastModifiedDatetime = m.LastModifiedDatetime;
                row["__operation"] = "query results";
                results.push(row);
            }
        }
        output["Results"] = results;
    }
    return output;
};

export const V1WorkGroupMembershipIDOCToArray = (input: any) => {
    let output: any = {};
    if (input["PlatformMessage"] && input["PlatformMessage"]["ListOfWorkGroupMembership"] !== undefined) {
        output["Count"] = input["PlatformMessage"]["ListOfWorkGroupMembership"].Count === undefined ? 0 : input["PlatformMessage"]["ListOfWorkGroupMembership"].Count;
        let results: any[] = [];
        if ("WorkGroupMembership" in input["PlatformMessage"]["ListOfWorkGroupMembership"]) {
            let rows = _asArray(input["PlatformMessage"]["ListOfWorkGroupMembership"]["WorkGroupMembership"]);
            for (let i = 0; i < rows.length; i++) {
                let m = rows[i];
                let row: any = {};
                row.RowNum = i;
                row.RowSelected = false;
                row.USID = m.USID;
                row.SourceUSID = m.SourceUSID;
                row.SourceType = m.SourceType;
                row.WorkGroup = m.WorkGroup;
                row.WorkGroupUSID = m.WorkGroupUSID;
                row.WorkGroupName = m.WorkGroupName;
                row.PrimaryAccountUserUSID = m.PrimaryAccountUserUSID;
                row.PrimaryAccountUserName = m.PrimaryAccountUserName;
                row.AccountUsers = _membershipAccountUsers(m);
                row.Realm = m.Realm;
                row.CreatedDatetime = m.CreatedDatetime;
                row.LastModifiedDatetime = m.LastModifiedDatetime;
                row["__operation"] = "query results";
                results.push(row);
            }
        }
        output["Results"] = results;
    }
    return output;
};

// ---------------------------------------------------------------------------
// Knowledge Catalog term permissions: Privilege (with nested groups + constraints).
// The v1.Privilege-001 response nests ListOfGroup (roles/groups that hold the privilege and
// their members) and ListOfPrivilegeConstraint (DENY constraints). Surfaced verbatim as row
// attributes for the PermissionConfiguration component. Ported from t1's V1PrivilegeIDOCToArray.
// ---------------------------------------------------------------------------
export const V1PrivilegeIDOCToArray = (input: any) => {
    let output: any = {};
    if (input["PlatformMessage"] && input.PlatformMessage["ListOfPrivilege"] !== undefined) {
        output["Count"] = input.PlatformMessage["ListOfPrivilege"].Count === undefined ? 0 : input.PlatformMessage["ListOfPrivilege"].Count;
        let results: any[] = [];
        if ("Privilege" in input.PlatformMessage["ListOfPrivilege"]) {
            let rows = _asArray(input.PlatformMessage["ListOfPrivilege"]["Privilege"]);
            for (let i = 0; i < rows.length; i++) {
                let privilege = rows[i];
                let row: any = {};
                row.RowNum = i;
                row.RowSelected = false;
                row.USID = privilege.USID;
                row.Name = privilege.Name;
                // CODE is what guards compare against (<objectType>:<verb>[:<Property>]); NAME is the display
                // label. ObjectType/Property disambiguate codes that read alike across object types.
                row.Code = privilege.Code;
                row.ObjectType = privilege.ObjectType;
                row.Property = privilege.Property;
                row.ListOfGroup = privilege.ListOfGroup;
                row.ListOfPrivilegeConstraint = privilege.ListOfPrivilegeConstraint;
                row.CreatedDatetime = privilege.CreatedDatetime;
                row.LastModifiedDatetime = privilege.LastModifiedDatetime;
                row.Keyword = privilege.Keyword;
                row.Realm = privilege.Realm;
                row["__operation"] = "query results";
                results.push(row);
            }
        }
        output["Results"] = results;
    }
    return output;
};

// ---------------------------------------------------------------------------------------------
// Data Quality Rule — same IDOC-to-buffer shape as the Enterprise Term converters above.
// ---------------------------------------------------------------------------------------------

export const V1RuleRevisionIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["PlatformMessage"] && input["PlatformMessage"]["ListOfRuleRevision"] !== undefined) {
        output["Count"] = input["PlatformMessage"]["ListOfRuleRevision"].Count === undefined ? 0 : input["PlatformMessage"]["ListOfRuleRevision"].Count;

        let results: any[] = [];

        if ("RuleRevision" in input["PlatformMessage"]["ListOfRuleRevision"]) {
            let node = input["PlatformMessage"]["ListOfRuleRevision"]["RuleRevision"];
            let rows = Array.isArray(node) ? node : [node];

            for (let i = 0; i < rows.length; i++) {
                let et = rows[i];
                let row: any = {};

                row.RowNum = i;
                row.RowSelected = false;

                row.USID = et.USID;
                row.RuleUSID = et.RuleUSID;
                // See the note in V1EnterpriseTermRevisionIDOCToArray: needed to decide whether the
                // caller is the creator, and so whether the lifecycle moves are worth offering.
                row.CreatedByUSID = et.CreatedByUSID;
                row.Revision = et.Revision;
                row.Status = et.Status;
                row.ApprovalStatus = et.ApprovalStatus;
                // True on the one revision the rule currently resolves to (latest PUBLISHED, else
                // DRAFT) — what the relationship rule pickers filter on to list one row per rule.
                row.IsCurrent = et.IsCurrent;
                row.Name = et.Name;
                row.Type = et.Type;
                row.Dimension = et.Dimension;
                row.Description = et.Description;
                row.PrimaryUserGroupPrimaryAccountUserName = et.PrimaryUserGroupPrimaryAccountUserName;
                row.PrimaryWorkGroupPrimaryAccountUserName = et.PrimaryWorkGroupPrimaryAccountUserName;
                row.PrimaryPositionUSID = et.PrimaryPositionUSID;
                // The primary position's NAME, joined server-side. Copied like any other field:
                // the document returns it, and a row that omits it leaves the grid's Stewardship
                // column blank while the API is plainly sending the value.
                row.PrimaryPositionName = et.PrimaryPositionName;
                row.PrimaryUserGroupUSID = et.PrimaryUserGroupUSID;
                row.PrimaryWorkGroupUSID = et.PrimaryWorkGroupUSID;
                row.CreatedDatetime = et.CreatedDatetime;
                row.LastModifiedDatetime = et.LastModifiedDatetime;
                row.EffectiveDatetime = et.EffectiveDatetime;
                row.ApprovedDatetime = et.ApprovedDatetime;
                row.Realm = et.Realm;
                row.Action = null;

                row["__operation"] = "query results";

                results.push(row);
            }
        }

        output["Results"] = results;
    }

    return output;
};

export const V1RuleRelationshipIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["PlatformMessage"] && input["PlatformMessage"]["ListOfRuleRelationship"] !== undefined) {
        output["Count"] = input["PlatformMessage"]["ListOfRuleRelationship"].Count === undefined ? 0 : input["PlatformMessage"]["ListOfRuleRelationship"].Count;

        let results: any[] = [];

        if ("RuleRelationship" in input["PlatformMessage"]["ListOfRuleRelationship"]) {
            let node = input["PlatformMessage"]["ListOfRuleRelationship"]["RuleRelationship"];
            let rows = Array.isArray(node) ? node : [node];

            for (let i = 0; i < rows.length; i++) {
                let r = rows[i];
                let row: any = {};

                row.RowNum = i;
                row.RowSelected = false;

                row.USID = r.USID;
                row.ParentUSID = r.ParentUSID;
                row.ChildUSID = r.ChildUSID;
                row.RelationshipTypeUSID = r.RelationshipTypeUSID;
                row.ParentName = r.ParentName;
                row.ChildName = r.ChildName;
                // ParentUSID/ChildUSID are LOGICAL rule USIDs; these resolve each end to the rule's
                // current revision. The revision USIDs are what the Rule Detail route is keyed on.
                row.ParentStatus = r.ParentStatus;
                row.ChildStatus = r.ChildStatus;
                row.ParentRevisionUSID = r.ParentRevisionUSID;
                row.ChildRevisionUSID = r.ChildRevisionUSID;
                row.RelationshipTypeName = r.RelationshipTypeName;
                // The type's two directional readings: Source = the parent's role, Target = the child's.
                row.SourceRelationshipName = r.SourceRelationshipName;
                row.TargetRelationshipName = r.TargetRelationshipName;
                row.CreatedDatetime = r.CreatedDatetime;
                row.LastModifiedDatetime = r.LastModifiedDatetime;
                row.Realm = r.Realm;
                row.Action = null;

                row["__operation"] = "query results";

                results.push(row);
            }
        }

        output["Results"] = results;
    }

    return output;
};

export const V1RuleAuditHistoryIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["PlatformMessage"] && input["PlatformMessage"]["ListOfRuleAuditHistory"] !== undefined) {
        output["Count"] = input["PlatformMessage"]["ListOfRuleAuditHistory"].Count === undefined ? 0 : input["PlatformMessage"]["ListOfRuleAuditHistory"].Count;

        let results: any[] = [];

        if ("RuleAuditHistory" in input["PlatformMessage"]["ListOfRuleAuditHistory"]) {
            let node = input["PlatformMessage"]["ListOfRuleAuditHistory"]["RuleAuditHistory"];
            let rows = Array.isArray(node) ? node : [node];

            for (let i = 0; i < rows.length; i++) {
                let r = rows[i];
                let row: any = {};

                row.RowNum = i;
                row.RowSelected = false;

                row.USID = r.USID;
                row.ModificationType = r.ModificationType;
                row.SessionIdentifier = r.SessionIdentifier;
                row.RuleUSID = r.RuleUSID;
                row.RuleRevisionUSID = r.RuleRevisionUSID;
                row.RevisionName = r.RevisionName;
                row.RuleRelationshipUSID = r.RuleRelationshipUSID;
                row.CreatedByUSID = r.CreatedByUSID;
                row.CreatedByName = r.CreatedByName;
                row.CreatedByEmail = r.CreatedByEmail;
                row.Change = decodeAuditChange(r.Change);
                row.CreatedDatetime = r.CreatedDatetime;
                row.LastModifiedDatetime = r.LastModifiedDatetime;
                row.Realm = r.Realm;
                row.Action = null;

                row["__operation"] = "query results";

                results.push(row);
            }
        }

        output["Results"] = results;
    }

    return output;
};

export const V1RuleTermIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["PlatformMessage"] && input["PlatformMessage"]["ListOfRuleTerm"] !== undefined) {
        output["Count"] = input["PlatformMessage"]["ListOfRuleTerm"].Count === undefined ? 0 : input["PlatformMessage"]["ListOfRuleTerm"].Count;

        let results: any[] = [];

        if ("RuleTerm" in input["PlatformMessage"]["ListOfRuleTerm"]) {
            let node = input["PlatformMessage"]["ListOfRuleTerm"]["RuleTerm"];
            let rows = Array.isArray(node) ? node : [node];

            for (let i = 0; i < rows.length; i++) {
                let r = rows[i];
                let row: any = {};

                row.RowNum = i;
                row.RowSelected = false;

                row.USID = r.USID;
                row.RuleUSID = r.RuleUSID;
                row.EnterpriseTermUSID = r.EnterpriseTermUSID;
                // EnterpriseTermUSID is a LOGICAL term USID; these resolve it to the term's last
                // PUBLISHED revision and are null when the term has none. TermRevisionUSID is what the
                // Term Detail route is keyed on.
                row.TermName = r.TermName;
                row.TermType = r.TermType;
                row.TermAbbreviation = r.TermAbbreviation;
                row.TermDescription = r.TermDescription;
                row.TermStatus = r.TermStatus;
                row.TermRevisionUSID = r.TermRevisionUSID;
                row.CreatedDatetime = r.CreatedDatetime;
                row.LastModifiedDatetime = r.LastModifiedDatetime;
                row.Realm = r.Realm;
                row.Action = null;

                row["__operation"] = "query results";

                results.push(row);
            }
        }

        output["Results"] = results;
    }

    return output;
};

// ---------------------------------------------------------------------------------------------
// Business processes (Glossary). Same IDOC-to-buffer shape as the rule converters above.
// ---------------------------------------------------------------------------------------------

export const V1BusinessProcessRevisionIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["PlatformMessage"] && input["PlatformMessage"]["ListOfBusinessProcessRevision"] !== undefined) {
        const list = input["PlatformMessage"]["ListOfBusinessProcessRevision"];
        output["Count"] = list.Count === undefined ? 0 : list.Count;

        let results: any[] = [];

        if ("BusinessProcessRevision" in list) {
            let node = list["BusinessProcessRevision"];
            let rows = Array.isArray(node) ? node : [node];

            for (let i = 0; i < rows.length; i++) {
                let r = rows[i];
                let row: any = {};

                row.RowNum = i;
                row.RowSelected = false;

                row.USID = r.USID;
                row.BusinessProcessUSID = r.BusinessProcessUSID;
                row.CreatedByUSID = r.CreatedByUSID;
                row.Revision = r.Revision;
                row.DisplayRevision = r.DisplayRevision;
                row.RevisionStage = r.RevisionStage;
                row.StageRevision = r.StageRevision;
                row.Status = r.Status;
                row.ApprovalStatus = r.ApprovalStatus;
                row.IsCurrent = r.IsCurrent;
                row.Name = r.Name;
                row.Description = r.Description;
                row.ParentBusinessProcessUSID = r.ParentBusinessProcessUSID;
                row.Criticality = r.Criticality;
                row.CriticalityRationale = r.CriticalityRationale;
                row.Impact = r.Impact;
                row.GoverningObjectUSID = r.GoverningObjectUSID;
                row.ReviewIntervalMonths = r.ReviewIntervalMonths;
                row.DataDomainUSID = r.DataDomainUSID;
                row.PrimaryPositionUSID = r.PrimaryPositionUSID;
                row.PrimaryPositionName = r.PrimaryPositionName;
                row.PrimaryUserGroupUSID = r.PrimaryUserGroupUSID;
                row.PrimaryUserGroupName = r.PrimaryUserGroupName;
                row.PrimaryWorkGroupUSID = r.PrimaryWorkGroupUSID;
                row.PrimaryWorkGroupName = r.PrimaryWorkGroupName;
                row.PrimaryUserGroupPrimaryAccountUserName = r.PrimaryUserGroupPrimaryAccountUserName;
                row.PrimaryWorkGroupPrimaryAccountUserName = r.PrimaryWorkGroupPrimaryAccountUserName;
                row.CreatedDatetime = r.CreatedDatetime;
                row.LastModifiedDatetime = r.LastModifiedDatetime;
                row.EffectiveDatetime = r.EffectiveDatetime;
                row.ApprovedDatetime = r.ApprovedDatetime;
                row.Realm = r.Realm;
                row.Action = null;

                row["__operation"] = "query results";

                results.push(row);
            }
        }

        output["Results"] = results;
    }

    return output;
};

export const V1BusinessProcessAuditHistoryIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["PlatformMessage"] && input["PlatformMessage"]["ListOfBusinessProcessAuditHistory"] !== undefined) {
        const list = input["PlatformMessage"]["ListOfBusinessProcessAuditHistory"];
        output["Count"] = list.Count === undefined ? 0 : list.Count;

        let results: any[] = [];

        if ("BusinessProcessAuditHistory" in list) {
            let node = list["BusinessProcessAuditHistory"];
            let rows = Array.isArray(node) ? node : [node];

            for (let i = 0; i < rows.length; i++) {
                let r = rows[i];
                let row: any = {};

                row.RowNum = i;
                row.RowSelected = false;

                row.USID = r.USID;
                row.ModificationType = r.ModificationType;
                row.SessionIdentifier = r.SessionIdentifier;
                row.BusinessProcessUSID = r.BusinessProcessUSID;
                row.BusinessProcessRevisionUSID = r.BusinessProcessRevisionUSID;
                row.RevisionName = r.RevisionName;
                row.BusinessProcessTermUSID = r.BusinessProcessTermUSID;
                row.CreatedByUSID = r.CreatedByUSID;
                row.CreatedByName = r.CreatedByName;
                row.CreatedByEmail = r.CreatedByEmail;
                row.Change = decodeAuditChange(r.Change);
                row.CreatedDatetime = r.CreatedDatetime;
                row.LastModifiedDatetime = r.LastModifiedDatetime;
                row.Realm = r.Realm;
                row.Action = null;

                row["__operation"] = "query results";

                results.push(row);
            }
        }

        output["Results"] = results;
    }

    return output;
};

export const V1ConnectionIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["PlatformMessage"] && input.PlatformMessage["ListOfConnection"] !== undefined) {
        if (input.PlatformMessage["ListOfConnection"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input.PlatformMessage["ListOfConnection"].Count;
        }

        let results: any[] = [];

        if ("Connection" in input.PlatformMessage["ListOfConnection"]) {
            let node = input.PlatformMessage["ListOfConnection"]["Connection"];
            let rows = Array.isArray(node) ? node : [node];

            for (let i = 0; i < rows.length; i++) {
                let record = rows[i];
                let row: any = {};

                row.RowNum = i;
                row.RowSelected = false;

                row.USID = record.USID;
                row.SourceUSID = record.SourceUSID;
                row.Name = record.Name;
                row.Description = record.Description;
                row.ConnectionType = record.ConnectionType;
                row.Dialect = record.Dialect;
                row.OverrideCatalogItemName = record.OverrideCatalogItemName;
                row.EnableExport = record.EnableExport;
                row.EnableAnalyticalQueries = record.EnableAnalyticalQueries;
                row.Configuration = record.Configuration;

                // Settings that vary by connection type are stored as JSON in one column; the form
                // edits them as ordinary fields, so they are lifted out here. Malformed JSON leaves the
                // fields empty rather than failing the whole list.
                row.Jdbc = null;
                if (record.Configuration) {
                    try {
                        let configuration = JSON.parse(record.Configuration);
                        if (configuration && typeof configuration === "object") {
                            row.Jdbc = configuration.jdbc ?? null;
                        }
                    } catch (e) {
                        row.Jdbc = null;
                    }
                }

                row.CreatedDatetime = record.CreatedDatetime;
                row.LastModifiedDatetime = record.LastModifiedDatetime;

                row["__operation"] = "query results";

                results.push(row);
            }
        }

        output["Results"] = results;
    }

    return output;
};

export const V1ConnectionCredentialIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["PlatformMessage"] && input.PlatformMessage["ListOfConnectionCredential"] !== undefined) {
        output["Count"] = input.PlatformMessage["ListOfConnectionCredential"].Count === undefined
            ? 0 : input.PlatformMessage["ListOfConnectionCredential"].Count;

        let results: any[] = [];

        if ("ConnectionCredential" in input.PlatformMessage["ListOfConnectionCredential"]) {
            let node = input.PlatformMessage["ListOfConnectionCredential"]["ConnectionCredential"];
            let rows = Array.isArray(node) ? node : [node];

            for (let i = 0; i < rows.length; i++) {
                let record = rows[i];
                let row: any = {};

                row.RowNum = i;
                row.RowSelected = false;

                row.USID = record.USID;
                row.ConnectionUSID = record.ConnectionUSID;
                row.UsageType = record.UsageType;
                row.AuthenticationType = record.AuthenticationType;
                row.Username = record.Username;
                // Masked by the document (userVisible false), so this is asterisks and never the
                // stored password. It is carried so the form can tell "a secret is set" from "none".
                row.Secret = record.Secret;
                row.IsDefault = record.IsDefault;
                row.Configuration = record.Configuration;

                // The secret-management settings are stored as JSON in one column and edited as
                // ordinary fields, so they are lifted out here. Malformed JSON leaves them empty
                // rather than failing the whole list.
                row.SecretManagement = false;
                row.SecretProvider = null;
                row.ResolveAt = null;
                row.UsernameSecret = null;
                row.PasswordSecret = null;
                row.SecretJsonPath = null;
                row.SecretRoleArn = null;
                row.SecretExternalId = null;
                row.SecretRegion = null;
                if (record.Configuration) {
                    try {
                        let configuration = JSON.parse(record.Configuration);
                        if (configuration && typeof configuration === "object") {
                            row.SecretManagement = configuration.secretManagement === true;
                            row.SecretProvider = configuration.provider === "ssm"
                                ? "AWS SSM Parameter Store" : (configuration.provider ? "AWS Secrets Manager" : null);
                            // Platform when unset, which is what the backend assumes too -- so an
                            // existing credential reads as what it has always done rather than blank.
                            row.ResolveAt = configuration.resolveAt === "agent" ? "Agent" : "Platform";
                            row.UsernameSecret = configuration.usernameSecret ?? null;
                            row.PasswordSecret = configuration.passwordSecret ?? null;
                            row.SecretJsonPath = configuration.jsonPath ?? null;
                            row.SecretRoleArn = configuration.roleArn ?? null;
                            row.SecretExternalId = configuration.externalId ?? null;
                            row.SecretRegion = configuration.region ?? null;
                        }
                    } catch (e) {
                        // leave the lifted fields empty
                    }
                }

                row.CreatedDatetime = record.CreatedDatetime;
                row.LastModifiedDatetime = record.LastModifiedDatetime;
                row.Action = null;

                row["__operation"] = "query results";

                results.push(row);
            }
        }

        output["Results"] = results;
    }

    return output;
};

// FlowRun: harvesting. Written by the service and the Batch job, read here -- so every field is
// copied straight through and none is derived.
export const V1FlowRunIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["PlatformMessage"] && input["PlatformMessage"]["ListOfFlowRun"] !== undefined) {
        output["Count"] = input["PlatformMessage"]["ListOfFlowRun"].Count === undefined ? 0 : input["PlatformMessage"]["ListOfFlowRun"].Count;

        let results: any[] = [];

        if ("FlowRun" in input["PlatformMessage"]["ListOfFlowRun"]) {
            let node = input["PlatformMessage"]["ListOfFlowRun"]["FlowRun"];
            let rows = Array.isArray(node) ? node : [node];

            for (let i = 0; i < rows.length; i++) {
                let record = rows[i];
                let row: any = {};

                row.RowNum = i;
                row.RowSelected = false;

                row.USID = record.USID;
                row.SourceUSID = record.SourceUSID;
                row.ConnectionUSID = record.ConnectionUSID;
                row.FlowType = record.FlowType;
                row.Status = record.Status;
                row.RequestedByUSID = record.RequestedByUSID;
                row.PrimaryPositionUSID = record.PrimaryPositionUSID;
                row.BatchJobId = record.BatchJobId;
                row.QueuedDatetime = record.QueuedDatetime;
                row.StartedDatetime = record.StartedDatetime;
                row.FinishedDatetime = record.FinishedDatetime;
                row.ItemsAdded = record.ItemsAdded;
                row.ItemsUpdated = record.ItemsUpdated;
                row.ItemsUnchanged = record.ItemsUnchanged;
                row.ItemsMissing = record.ItemsMissing;
                row.ErrorCode = record.ErrorCode;
                row.ErrorCause = record.ErrorCause;
                row.Action = null;
                row["__operation"] = "query results";

                results.push(row);
            }
        }

        output["Results"] = results;
    }

    return output;
};

// FlowRunLog: harvesting. Written by the service and the Batch job, read here -- so every field is
// copied straight through and none is derived.
export const V1FlowRunLogIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["PlatformMessage"] && input["PlatformMessage"]["ListOfFlowRunLog"] !== undefined) {
        output["Count"] = input["PlatformMessage"]["ListOfFlowRunLog"].Count === undefined ? 0 : input["PlatformMessage"]["ListOfFlowRunLog"].Count;

        let results: any[] = [];

        if ("FlowRunLog" in input["PlatformMessage"]["ListOfFlowRunLog"]) {
            let node = input["PlatformMessage"]["ListOfFlowRunLog"]["FlowRunLog"];
            let rows = Array.isArray(node) ? node : [node];

            for (let i = 0; i < rows.length; i++) {
                let record = rows[i];
                let row: any = {};

                row.RowNum = i;
                row.RowSelected = false;

                row.USID = record.USID;
                row.FlowRunUSID = record.FlowRunUSID;
                row.SourceUSID = record.SourceUSID;
                row.Sequence = record.Sequence;
                row.Severity = record.Severity;
                row.Message = record.Message;
                row.Detail = record.Detail;
                row.LoggedDatetime = record.LoggedDatetime;
                row.Action = null;
                row["__operation"] = "query results";

                results.push(row);
            }
        }

        output["Results"] = results;
    }

    return output;
};

// SourceSchedule: harvesting. Written by the service and the Batch job, read here -- so every field is
// copied straight through and none is derived.
export const V1SourceScheduleIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["PlatformMessage"] && input["PlatformMessage"]["ListOfSourceSchedule"] !== undefined) {
        output["Count"] = input["PlatformMessage"]["ListOfSourceSchedule"].Count === undefined ? 0 : input["PlatformMessage"]["ListOfSourceSchedule"].Count;

        let results: any[] = [];

        if ("SourceSchedule" in input["PlatformMessage"]["ListOfSourceSchedule"]) {
            let node = input["PlatformMessage"]["ListOfSourceSchedule"]["SourceSchedule"];
            let rows = Array.isArray(node) ? node : [node];

            for (let i = 0; i < rows.length; i++) {
                let record = rows[i];
                let row: any = {};

                row.RowNum = i;
                row.RowSelected = false;

                row.USID = record.USID;
                row.SourceUSID = record.SourceUSID;
                row.FlowType = record.FlowType;
                row.Mode = record.Mode;
                row.Frequency = record.Frequency;
                row.RunAtTime = record.RunAtTime;
                row.CronExpression = record.CronExpression;
                row.Timezone = record.Timezone;
                row.ValidFrom = record.ValidFrom;
                row.ValidTo = record.ValidTo;
                row.Enabled = record.Enabled;
                row.CatchUp = record.CatchUp;
                row.NextRunDatetime = record.NextRunDatetime;
                row.LastRunDatetime = record.LastRunDatetime;
                row.Action = null;
                row["__operation"] = "query results";

                results.push(row);
            }
        }

        output["Results"] = results;
    }

    return output;
};

// Data types (t5/v1/data_types -> v1.DataType-001). The DataTypeRevision is what travels, because a
// revision is what anything points at; TypeName and TypeCode arrive with it through the join to the
// logical type rather than being copied onto each revision.
//
// EVERY FIELD THE IDOC DECLARES IS COPIED. A converter that quietly omits one leaves the grid
// rendering a column the buffer never received, which looks like missing data rather than a missing
// line here.
export const V1DataTypeIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["PlatformMessage"] && input["PlatformMessage"]["ListOfDataTypeRevision"] !== undefined) {
        output["Count"] = input["PlatformMessage"]["ListOfDataTypeRevision"].Count === undefined ? 0 : input["PlatformMessage"]["ListOfDataTypeRevision"].Count;

        let results: any[] = [];

        if ("DataTypeRevision" in input["PlatformMessage"]["ListOfDataTypeRevision"]) {
            let node = input["PlatformMessage"]["ListOfDataTypeRevision"]["DataTypeRevision"];
            let rows = Array.isArray(node) ? node : [node];

            for (let i = 0; i < rows.length; i++) {
                let dt = rows[i];
                let row: any = {};

                row.RowNum = i;
                row.RowSelected = false;

                row.USID = dt.USID;
                row.DataTypeUSID = dt.DataTypeUSID;
                row.TypeName = dt.TypeName;
                row.TypeCode = dt.TypeCode;
                // The tenant's organisation of the catalogue. Copied across explicitly because this
                // converter enumerates its fields: one left out is absent from every row, which
                // shows as an empty column rather than an error -- the same silent drop that hides
                // an omitted handler argument.
                row.TypeClassification = dt.TypeClassification;
                row.Revision = dt.Revision;
                row.IsCurrent = dt.IsCurrent;
                row.Status = dt.Status;
                row.Description = dt.Description;
                row.Kind = dt.Kind;
                row.PhysicalType = dt.PhysicalType;
                row.Cardinality = dt.Cardinality;
                // Base64 JSON. Carried across as it arrives; resolverSummary is what reads it.
                row.Resolver = dt.Resolver;
                // ...and taken apart, so the detail form has something to show when revising. These
                // two are what a person supplies; the resolver document is assembled from them.
                const resolver = decodeResolver(dt.Resolver);
                row.ResolverKind = resolver.kind;
                // The same target, into whichever field that kind's control reads. A lookup is
                // chosen from a list and the others are typed, so they cannot share a control -- and
                // Revise has to fill the one that will be on screen or it opens looking empty.
                row.ResolverTarget = resolver.kind === "Lookup" ? "" : resolver.target;
                row.ResolverLookupUSID = resolver.kind === "Lookup" ? resolver.target : "";
                row.CompositeRevisionUSID = dt.CompositeRevisionUSID;
                row.CreatedDatetime = dt.CreatedDatetime;
                row.LastModifiedDatetime = dt.LastModifiedDatetime;
                row.Realm = dt.Realm;
                row.Action = null;

                row["__operation"] = "query results";

                results.push(row);
            }
        }

        output["Results"] = results;
    }

    return output;
};
